import React from 'react';
import { Typography } from '@material-ui/core';
import { firstWordUppercase } from '../../../../utils';
import { CogTooltipContentProps, RechartsTooltipProps } from '../types';
import CustomTooltip from '../../../BuildingBlocks/Tooltip/Tooltip';
import makeStyles from '@material-ui/core/styles/makeStyles';
import CogTooltipItem from './CogTooltipItem';

const useStyles = makeStyles((theme: any) => ({
  tooltipTitle: {
    color: theme.palette.brand.white,
    textAlign: 'left',
    lineHeight: `${theme.spacing(2)}px`,
  },
}));

function CogTooltipContent({ label, payload }: CogTooltipContentProps) {
  const classes = useStyles({});
  return (
    <div>
      <Typography variant="body2" className={classes.tooltipTitle}>
        {firstWordUppercase(label)}
      </Typography>
      {payload.map(({ name, value }) => (
        <CogTooltipItem key={name} name={name} value={value} />
      ))}
    </div>
  );
}

export default function CogTooltip({
  active,
  coordinate,
  payload,
  label,
}: RechartsTooltipProps) {
  if (!active || !payload) return null;
  const { x, y } = coordinate || {};
  return (
    <CustomTooltip
      placement="top"
      open={true}
      title={<CogTooltipContent payload={payload} label={label} />}
    >
      <div style={{ position: 'absolute', top: y + 5, left: x }}></div>
    </CustomTooltip>
  );
}
